import React, { useState, useEffect } from "react";
import "./style.css";
import jwt_decode from "jwt-decode";
import axiosInstance from "../../utils/config";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getForm } from "../../actions/forms";

function ResetPassword({ match, history }) {
  let _id = "";
  const [resetToken, setResetToken] = useState("");
  if (!match.params.id || !match.params.token) history.push("/");
  else {
    const { id, token } = match.params;
    _id = id;
    setResetToken(token);
    let decodedToken = jwt_decode(token),
      newDate = new Date();
    if (decodedToken.exp < newDate.getTime()) history.push("/");
  }
  console.log(match.params.id);
  const dispatch = useDispatch(),
    [passwords, setPasswords] = useState({
      newPassword: "",
      newPasswordConfirm: "",
    }),
    [errors, setErrors] = useState([]),
    [successMsg, setSuccessMsg] = useState(""),
    onInput = (e) => {
      const { name, value } = e.target;
      setPasswords({ [name]: value });
    },
    onSubmit = (e) => {
      e.preventDefault();
      const { newPassword, newPasswordConfirm } = passwords;
      if (newPassword.length < 3)
        setErrors(["The password must be at least 3 characters long."]);
      else if (newPassword.length > 100)
        setErrors(["The password must be 100 characters long maximum."]);
      else if (newPassword !== newPasswordConfirm)
        setErrors(["Please confirm the new password correctly."]);
      else {
        setErrors([]);
        setSuccessMsg("You've successfully changed your password.");
        axiosInstance
          .post(`/resetPassword/${_id}/${resetToken}`, { newPassword })
          .then((res) => {
            return null;
          })
          .catch((err) => {
            setErrors([err]);
          });
      }
    };
  useEffect(() => {
    document.title = "Ski Design | Reset Password";
  }, []);
  return (
    <div className="reset-page">
      <div className="form-container">
        <div className="upper-rotated-container"></div>
        <div className="login-form-cont form-cont position-relative">
          <h2 className="form-header">Reset Password</h2>
          <p className="under-header mb-5">Type in a new password.</p>
          {errors.length > 0 && (
            <div className="alert alert-danger text-center" role="alert">
              {errors[0]}
            </div>
          )}
          {successMsg.split("").length > 0 && (
            <div className="alert alert-success text-center" role="alert">
              {successMsg}
            </div>
          )}
          <form
            className="d-flex flex-column align-items-center justify-content-center"
            onSubmit={(e) => onSubmit(e)}
          >
            <input
              type="password my-2"
              name="newPassword"
              required
              placeholder="New password"
              className="password1"
              onInput={(e) => onInput(e)}
            />
            <input
              type="password my-2"
              name="newPasswordConfirm"
              required
              placeholder="Re-type new password"
              className="password2"
            />
            <button className="login-submit-btn mt-5 mb-3">Done</button>
            <p className="text-center" style={{ color: "#32403B" }}>
              Remembered Password?
              <Link
                className="link-text"
                onClick={() => dispatch(getForm("login"))}
                to="/"
              >
                Log In
              </Link>
            </p>
          </form>
        </div>
        <div className="lower-rotated-container"></div>
      </div>
    </div>
  );
}

export default ResetPassword;
